export const UPDATE_PARENTAL_LOCK_CONFIRMED = 'UPDATE_PARENTAL_LOCK_CONFIRMED';
export const UPDATE_VIDEO_STATE_NEXT_VIDEO_IS_BINGE = 'UPDATE_VIDEO_STATE_NEXT_VIDEO_IS_BINGE';
export const UPDATE_ACCESS_VERSION_CHOICE = 'UPDATE_ACCESS_VERSION_CHOICE';

export function updateVideoStateNextVideoIsBinge(isBinge, isAutoPlay = false) {
    return {
        type: UPDATE_VIDEO_STATE_NEXT_VIDEO_IS_BINGE,
        payload: {
            isBinge,
            isAutoPlay,
        },
    };
}

export function updateParentalLockConfirmed(payload) {
    return {
        type: UPDATE_PARENTAL_LOCK_CONFIRMED,
        payload,
    };
}

export function updateAccessVersionChoice(payload) {
    return {
        type: UPDATE_ACCESS_VERSION_CHOICE,
        persistent: true,
        payload,
    };
}
